var $ = require('jquery');

$(document).ready(function() {
    initAlert();
})
function initAlert() {
    $('.alert').each(function() {
        var prev = $(this).prev();

        if(prev.hasClass('wp-block-columns')) {
            var prevPrev = prev.prev();
            
            if(prevPrev.length == 0) {
                $(this).addClass('-over');
            }
        }
    })
}